import { render, staticRenderFns } from "./LayoutMinimal.vue?vue&type=template&id=011363d3&scoped=true&"
import script from "./LayoutMinimal.vue?vue&type=script&lang=js&"
export * from "./LayoutMinimal.vue?vue&type=script&lang=js&"
import style0 from "./LayoutMinimal.vue?vue&type=style&index=0&id=011363d3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011363d3",
  null
  
)

component.options.__file = "LayoutMinimal.vue"
export default component.exports